import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { Observable, of } from "rxjs";
import { AppConstants } from "../../app.constants";
import { map } from "rxjs/operators";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: "root",
})
export class ScrapingupdateService {
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getMoleculeData(data) {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SCRAPINGUPDATE.MOLECULE_LIST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getScrapingFieldData(data) {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SCRAPINGUPDATE.SCRAPINGFIELD_LIST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getSpecifiecOneFieldData(data) {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SCRAPINGUPDATE.SPACIFIECONEFIELDDATA}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getApprovedFieldData(data) {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SCRAPINGUPDATE.APPROVALFIELDDATA}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRejectFieldData(data) {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SCRAPINGUPDATE.REJECTFIELDDATA}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
